import type { FaireProductEntity } from "../../entity_types/product";

export const p_qburetnwww: FaireProductEntity = {
  token: "p_qburetnwww",
  type: "product",
  name: "Through the Woods Little Stickies",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/4132a6bba244183485231e650d3e32d954607a371f986018bf71469589817cd5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fc2ff14c885e4ec0e807687069aaffe066040aae361914654c174a72e66521d2.jpeg",
    "https://cdn.faire.com/fastly/313fae5c3343ef2d4603a128cf88b332d5464cf16aecb09aa2ff08c3198ac254.jpeg",
  ],
  priceDollars: 5,
  description:
    "Because sometimes you need a little adhesive! Sweet watercolor illustrations bring joy to everyday tasks - perfect for your desk, home, bathroom mirrors, foreheads. The best part? They’re made in partnership with 3M, which means you get that classic Post-it® Notes stickiness that actually sticks!",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:57.841Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
